"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.plaintextKeyHandler = void 0;
var stellar_sdk_1 = require("@stellar/stellar-sdk");
var Types_1 = require("../Types");
exports.plaintextKeyHandler = {
    keyType: Types_1.KeyType.plaintextKey,
    signTransaction: function (params) {
        var transaction = params.transaction, key = params.key;
        if (key.privateKey === "") {
            throw new Error("Non-plaintext key sent to plaintext handler: ".concat(JSON.stringify(key.publicKey)));
        }
        var keyPair = stellar_sdk_1.Keypair.fromSecret(key.privateKey);
        /*
         * NOTE: we need to use the combo of getKeypairSignature() + addSignature()
         * here in place of the shorter sign() call because sign() results in a
         * "XDR Write Error: [object Object] is not a DecoratedSignature" error
         * on React Native whenever we try to call transaction.toXDR() on the signed
         * transaction.
         */
        var signature = transaction.getKeypairSignature(keyPair);
        transaction.addSignature(keyPair.publicKey(), signature);
        return Promise.resolve(transaction);
    },
};
